import React from 'react'
import { useRemoteStrings } from '@acorns/web-utils'
import {
  PromoCodeSubTextContainer,
  StyledCircleCheckIconSubText,
  StyledCircleXIcon,
  ValidationSubText,
} from '../styled-components'

interface Props {
  isValidSubTextShown: boolean
}

export const PromoCodeValidationSubText = ({ isValidSubTextShown }: Props) => {
  const { getRemoteString } = useRemoteStrings()

  return (
    <PromoCodeSubTextContainer isValidSubTextShown={isValidSubTextShown}>
      {isValidSubTextShown ? (
        <>
          <StyledCircleCheckIconSubText />
          <ValidationSubText>
            {getRemoteString({ key: 'create_account.promo_code_drawer.input_field.valid' })}
          </ValidationSubText>
        </>
      ) : (
        <>
          <StyledCircleXIcon />
          <ValidationSubText>
            {getRemoteString({ key: 'create_account.promo_code_drawer.input_field.error' })}
          </ValidationSubText>
        </>
      )}
    </PromoCodeSubTextContainer>
  )
}
